import { Component, TemplateFunction, ScopeBase } from '@ribajs/core'
import {
  ShopifyDiscountApplication,
  ShopifyDiscountAllocation,
} from '../types/index.js'

interface Scope extends ScopeBase {
  discounts: (ShopifyDiscountApplication | ShopifyDiscountAllocation)[] | null
  normalizedDiscounts: ShopifyDiscountApplication[]
  hidePrice: boolean
}

export class SbCartDiscountsComponent extends Component {
  public static tagName = 'sb-cart-discounts'

  lifecycleOptions = {
    ignore: true,
  }

  static get observedAttributes(): string[] {
    return ['discounts', 'hide-price']
  }

  protected requiredAttributes(): string[] {
    return ['discounts']
  }

  public scope: Scope = {
    discounts: null,
    normalizedDiscounts: [],
    hidePrice: false,
  }

  constructor() {
    super()
  }

  protected connectedCallback() {
    super.connectedCallback()
    this.init(SbCartDiscountsComponent.observedAttributes)
  }

  protected parsedAttributeChangedCallback(
    attributeName: string,
    oldValue: any,
    newValue: any,
  ) {
    switch (attributeName) {
      case 'discounts':
        this.scope.normalizedDiscounts = this.normalizeDiscounts(newValue)
        this.scope.normalizedDiscounts = this.mergeDiscounts(
          this.scope.normalizedDiscounts,
        )
        break
    }
  }

  /**
   * Normalize the discounts array, if an item is a `discount_allocation`, then return the `discount_application`.
   * ALso ignore discounts with amount 0.
   * @param discounts
   * @returns
   */
  protected normalizeDiscounts(
    discounts: (ShopifyDiscountApplication | ShopifyDiscountAllocation)[] = [],
  ): ShopifyDiscountApplication[] {
    let changed = false
    const normalizedDiscounts: ShopifyDiscountApplication[] = []

    for (const discount of discounts) {
      if ((discount as ShopifyDiscountAllocation).discount_application) {
        changed = true
        if ((discount as ShopifyDiscountAllocation).amount > 0) {
          normalizedDiscounts.push(
            (discount as ShopifyDiscountAllocation).discount_application,
          )
        }
        // Ignore discounts with amount 0
      } else {
        normalizedDiscounts.push(discount as ShopifyDiscountApplication)
      }
    }

    if (changed) {
      return normalizedDiscounts
    } else {
      return discounts as ShopifyDiscountApplication[]
    }
  }

  /**
   * Merge discounts with the same title
   */
  mergeDiscounts(discounts: ShopifyDiscountApplication[]) {
    const groupedDiscounts: {
      [key: string]: ShopifyDiscountApplication[]
    } = {}

    for (const discount of discounts) {
      if (groupedDiscounts.hasOwnProperty(discount.title)) {
        groupedDiscounts[discount.title].push(discount)
      } else {
        groupedDiscounts[discount.title] = [discount]
      }
    }

    const mergedDiscounts: ShopifyDiscountApplication[] = []

    for (const title in groupedDiscounts) {
      const group = groupedDiscounts[title]
      const mergedDiscount = group[0]

      for (let i = 1; i < group.length; i++) {
        mergedDiscount.total_allocated_amount += group[i].total_allocated_amount
      }

      mergedDiscounts.push(mergedDiscount)
    }

    return mergedDiscounts
  }

  protected async beforeBind() {
    await super.beforeBind()
    this.addEventListeners()
  }

  protected async afterBind() {
    this.debug('afterBind', this.scope)
    this.classList.add(`${SbCartDiscountsComponent.tagName}-ready`)
    await super.afterBind()
  }

  protected disconnectedCallback() {
    super.disconnectedCallback()
    this.removeEventListeners()
  }

  protected addEventListeners() {
    //
  }

  protected removeEventListeners() {
    //
  }

  protected template(): ReturnType<TemplateFunction> {
    return null
  }
}
